import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MfaService } from '../../../core/services/mfa.service';
import { AuthService } from '../../../core/services/auth.service';

@Component({
  selector: 'app-mfa-required',
  templateUrl: './mfa-required.component.html',
  styleUrls: ['./mfa-required.component.scss'],
})
export class MfaRequiredComponent implements OnInit {
  form!: FormGroup;
  qrCode = '';
  secret = '';
  recoveryCodes: string[] = [];
  step: 'intro' | 'qr' | 'verify' | 'codes' = 'intro';
  loading = false;

  constructor(
    private fb: FormBuilder,
    private mfaService: MfaService,
    private auth: AuthService,
    private router: Router,
    private snackBar: MatSnackBar,
  ) {}

  ngOnInit(): void {
    if (!this.auth.isLoggedIn()) {
      this.router.navigate(['/login']);
      return;
    }
    this.form = this.fb.group({
      token: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]],
    });
  }

  startSetup(): void {
    this.loading = true;
    this.mfaService.setup().subscribe({
      next: (res) => {
        this.qrCode = res.data.qrCode;
        this.secret = res.data.secret;
        this.step = 'qr';
        this.loading = false;
      },
      error: () => {
        this.loading = false;
        this.snackBar.open('Erro ao iniciar configuração do MFA.', 'Fechar', { duration: 4000 });
      },
    });
  }

  nextStep(): void {
    this.step = 'verify';
  }

  verifyCode(): void {
    if (this.form.invalid) return;
    this.loading = true;
    this.mfaService.verifySetup(this.form.value.token).subscribe({
      next: (res) => {
        this.recoveryCodes = res.data.recoveryCodes;
        this.step = 'codes';
        this.loading = false;
        // Sync in-memory user (BehaviorSubject + localStorage) so MfaRequiredGuard allows navigation
        const user = this.auth.getCurrentUser();
        if (user) {
          this.auth.updateCurrentUser({ ...user, mfaEnabled: true });
        }
        this.snackBar.open('MFA ativado com sucesso!', 'OK', { duration: 3000, panelClass: ['snackbar-success'] });
      },
      error: () => {
        this.loading = false;
        this.snackBar.open('Código inválido. Tente novamente.', 'Fechar', { duration: 4000 });
      },
    });
  }

  copyCodes(): void {
    navigator.clipboard.writeText(this.recoveryCodes.join('\n'));
    this.snackBar.open('Códigos copiados!', 'OK', { duration: 2000 });
  }

  cancel(): void {
    this.auth.logout();
  }

  finish(): void {
    this.router.navigate(['/dashboard']);
  }
}
